function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z",
  fill: "#333"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyIDEyQzIyIDYuNDc3MTIgMTcuNTIyOSAxLjk5OTk3IDEyIDEuOTk5OTdDNi40NzcxNSAxLjk5OTk3IDIgNi40NzcxMiAyIDEyQzIgMTYuOTkxMyA1LjY1Njg2IDIxLjEyODMgMTAuNDM3NSAyMS44Nzg1VjE0Ljg5MDZINy44OTg0NFYxMkgxMC40Mzc1VjkuNzk2ODVDMTAuNDM3NSA3LjI5MDU5IDExLjkzMDQgNS45MDYyMiAxNC4yMTQ3IDUuOTA2MjJDMTUuMzA4NyA1LjkwNjIyIDE2LjQ1MzEgNi4xMDE1MyAxNi40NTMxIDYuMTAxNTNWOC41NjI0N0gxNS4xOTIyQzEzLjk0OTkgOC41NjI0NyAxMy41NjI1IDkuMzMzMzEgMTMuNTYyNSAxMC4xMjQxVjEySDE2LjMzNkwxNS44OTI2IDE0Ljg5MDZIMTMuNTYyNVYyMS44Nzg1QzE4LjM0MzIgMjEuMTI4MyAyMiAxNi45OTEzIDIyIDEyWiIgZmlsbD0iIzMzMzMzMyIvPgo8L3N2Zz4K";
export { SvgFacebook as ReactComponent };